// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Actions import
import {
    setTokenAnalyzerStats,
    setCheckWalletStats,
    setAiCheckWalletProcessing,
    setAiCheckWalletError,
    setAiNewText,
    unsetAiNewText,
    setCheckWalletProcessingStats,
    showNotification,
    hideNotification,
    changeUserData,
    setAiTokenAnalyzerProcessing,
    setTokenAnalyzerProcessingStats
} from "../../actions";
// Hooks imports
import { apiRequests } from "../../hooks/apiRequests";
// Styles imports
import './TokenAnalyzerSearch.css';
import '../../util.css'
// Import Svg icons
import { ReactComponent as SearchStatusSvg } from '../../svg-icons/search-status.svg';
import { ReactComponent as ArrowRightSvg } from '../../svg-icons/arrow-right.svg';
// Const imports
import {
    BASE,
    BSC,
    ETH,
    TOKEN_ANALYZER_PAUSES,
    TOKEN_ANALYZER_TRY_NUMBER
} from "../../consts/consts";

function isValidEthereumAddress(address) {
    const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return ethAddressRegex.test(address);
}

class TokenAnalyzerSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {inputData: ""};
    }

    setNotification = (message, duration = 750) => {
        const { showNotification, hideNotification } = this.props;
        showNotification({message: message, duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    keyDown = async (event) => {

        const { parseTokenAnalyzerResult, reqTokenAnalyzerOrSetTask } = apiRequests();
        const { setTokenAnalyzerStats, setAiTokenAnalyzerProcessing,setAiNewText,
            setTokenAnalyzerProcessingStats, changeUserData } = this.props;
        const { blockchain } = this.props.blockchain;
        const { id, token, num_of_token_analyzer_req, ai_energy } = this.props.userData;

        const { status } = this.props.tokenAnalyzer;

        const wait = t => new Promise(s => setTimeout(s, t));

        if (event.key === "Enter") {

            if (num_of_token_analyzer_req <= 0 && ai_energy < 500) {
                this.setNotification("Not enough AI energy", 1500);
                return null;
            }
            if (num_of_token_analyzer_req <= 0){
                this.setNotification("Token Analyzer request limit exceeded", 1500);
                return null;
            }
            if (ai_energy < 500) {//100 затраты на check wallet
                this.setNotification("Not enough AI energy", 1500);
                return null;
            }

            if ((blockchain === ETH || blockchain === BASE || blockchain === BSC) && isValidEthereumAddress(this.state.inputData)) {
                ///////////////
                try {
                    event.target.blur();

                    let response = await reqTokenAnalyzerOrSetTask(id, token, blockchain, this.state.inputData);

                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    if(response['status'] === "RESULT") {
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }
                        setTokenAnalyzerStats(parseTokenAnalyzerResult(response['data']));
                    } else if (response['status'] === "PROCESSING") {
                        let task = response['task'];
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }
                        for (let i = 0; i < TOKEN_ANALYZER_TRY_NUMBER; i++) {
                            setAiTokenAnalyzerProcessing();
                            setAiNewText();
                            setTokenAnalyzerProcessingStats();
                            await wait(TOKEN_ANALYZER_PAUSES[i]);
                            let response = await reqTokenAnalyzerOrSetTask(id, token, blockchain, this.state.inputData, task);
                            if(response['status'] === "RESULT") {
                                setTokenAnalyzerStats(parseTokenAnalyzerResult(response['data']));
                                if ('user_info' in response) {
                                    changeUserData(response['user_info']);
                                }
                                break;
                            }
                            if(response['status'] === "ERROR") {
                                this.setNotification("Request error. Attempt " + (i+1) +"/"+TOKEN_ANALYZER_TRY_NUMBER, 2500);
                                if ((i+1) === TOKEN_ANALYZER_TRY_NUMBER) {
                                    this.setNotification("Request error.\nTry again later.", 2500);
                                    break;
                                }
                            }
                            if ((i+1) === TOKEN_ANALYZER_TRY_NUMBER) {
                                this.setNotification("Number of attempts expired.", 1500);
                            }
                        }
                    } else if (response['status'] === "ERROR") {
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }
                        if(response['code'] === 410) {
                            this.setNotification("Not enough AI energy", 1500);
                        } else if (response['code'] === 411) {
                            this.setNotification("Token Analyzer request limit exceeded", 1500);
                        } else if (response['code'] === 404) {
                            this.setNotification("There is no connection with the AI", 1500);
                        } else if (response['code'] === 403) {
                            this.setNotification("Invalid username/token", 1500);
                        } else if (response['code'] === 500) {
                            this.setNotification("Internal Server Error", 1500);
                        } else {
                            this.setNotification("Unknown error", 1500);
                        }
                    }
                } catch (error) {
                    this.setNotification("Unknown error. Try again.", 1500);
                }
                /////////////
            } else {
                this.setNotification("Invalid token address.", 1500);
            }
        }
    };

    handleChange = (event) => {
        this.setState({inputData: event.target.value});
    }

    handleClick = async () => {
        const { parseTokenAnalyzerResult, reqTokenAnalyzerOrSetTask } = apiRequests();
        const { setTokenAnalyzerStats, setAiTokenAnalyzerProcessing,setAiNewText,
            setTokenAnalyzerProcessingStats, changeUserData } = this.props;
        const { blockchain } = this.props.blockchain;
        const { id, token, num_of_token_analyzer_req, ai_energy } = this.props.userData;

        const { status } = this.props.tokenAnalyzer;

        const wait = t => new Promise(s => setTimeout(s, t));

        if (num_of_token_analyzer_req <= 0 && ai_energy < 500) {
            this.setNotification("Not enough AI energy", 1500);
            return null;
        }
        if (num_of_token_analyzer_req <= 0){
            this.setNotification("Token Analyzer request limit exceeded", 1500);
            return null;
        }
        if (ai_energy < 500) {
            this.setNotification("Not enough AI energy", 1500);
            return null;
        }

        if ((blockchain === ETH || blockchain === BASE || blockchain === BSC) && isValidEthereumAddress(this.state.inputData)) {
            ///////////////
            try {

                let response = await reqTokenAnalyzerOrSetTask(id, token, blockchain, this.state.inputData);

                if ('user_info' in response) {
                    changeUserData(response['user_info']);
                }
                if(response['status'] === "RESULT") {
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    setTokenAnalyzerStats(parseTokenAnalyzerResult(response['data']));
                } else if (response['status'] === "PROCESSING") {
                    let task = response['task'];
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    for (let i = 0; i < TOKEN_ANALYZER_TRY_NUMBER; i++) {
                        setAiTokenAnalyzerProcessing();
                        setAiNewText();
                        setTokenAnalyzerProcessingStats();
                        await wait(TOKEN_ANALYZER_PAUSES[i]);
                        let response = await reqTokenAnalyzerOrSetTask(id, token, blockchain, this.state.inputData, task);
                        if(response['status'] === "RESULT") {
                            setTokenAnalyzerStats(parseTokenAnalyzerResult(response['data']));
                            if ('user_info' in response) {
                                changeUserData(response['user_info']);
                            }
                            break;
                        }
                        if(response['status'] === "ERROR") {
                            this.setNotification("Request error. Attempt " + (i+1) +"/"+TOKEN_ANALYZER_TRY_NUMBER, 2500);
                            if ((i+1) === TOKEN_ANALYZER_TRY_NUMBER) {
                                this.setNotification("Request error.\nTry again later.", 2500);
                                break;
                            }
                        }
                        if ((i+1) === TOKEN_ANALYZER_TRY_NUMBER) {
                            this.setNotification("Number of attempts expired.", 1500);
                        }
                    }
                } else if (response['status'] === "ERROR") {
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    if(response['code'] === 410) {
                        this.setNotification("Not enough AI energy", 1500);
                    } else if (response['code'] === 411) {
                        this.setNotification("Token Analyzer request limit exceeded", 1500);
                    } else if (response['code'] === 404) {
                        this.setNotification("There is no connection with the AI", 1500);
                    } else if (response['code'] === 403) {
                        this.setNotification("Invalid username/token", 1500);
                    } else if (response['code'] === 500) {
                        this.setNotification("Internal Server Error", 1500);
                    } else {
                        this.setNotification("Unknown error", 1500);
                    }
                }
            } catch (error) {
                this.setNotification("Unknown error. Try again.", 1500);
            }
            /////////////
        } else {
            this.setNotification("Invalid token address.", 1500);
        }

    };

    render () {
        return (
            <div className={"token-analyzer__search"}>
                <SearchStatusSvg className={"token-analyzer__search-icon"}/>
                <input type={"search"} className={"token-analyzer__search-input"} onKeyDown = {this.keyDown} onChange={this.handleChange}/>
                <div className={"token-analyzer__search-block"} onClick={this.handleClick}>
                    <ArrowRightSvg className={"token-analyzer__arrow-right-icon"}/>
                </div>

            </div>
        );
    }

}

const mapStateToProps = ({ tokenAnalyzer, blockchain, userData }) => {
    return { tokenAnalyzer, blockchain, userData };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setTokenAnalyzerStats: setTokenAnalyzerStats,
        setCheckWalletStats: setCheckWalletStats,
        setAiCheckWalletProcessing: setAiCheckWalletProcessing,
        setAiCheckWalletError: setAiCheckWalletError,
        setAiNewText: setAiNewText,
        unsetAiNewText: unsetAiNewText,
        setCheckWalletProcessingStats: setCheckWalletProcessingStats,
        showNotification: showNotification,
        hideNotification: hideNotification,
        changeUserData: changeUserData,
        setAiTokenAnalyzerProcessing: setAiTokenAnalyzerProcessing,
        setTokenAnalyzerProcessingStats: setTokenAnalyzerProcessingStats
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenAnalyzerSearch);
